import * as Namespaces from './namespaces'

const locales = {
	[Namespaces.RATES]: {
		el: {
			'Date already exists!': 'Υπάρχει ήδη καταχώρηση για αυτήν την ημερομηνία!',
			'Rates' : 'Ποσοστά',
			'Contribution Rate' : 'Ποσοστό Εισφορών',
			'Salary Increase Rate' : 'Ποσοστό Προσαύξησης Μισθού',
			'From Date' : 'Από ημ/νία',
			'Contribution Rate updated successfully!' : 'Το ποσοστό εισφορών ανανεώθηκε με επιτυχία!',
			'Contribution Rate created successfully!' : 'Το ποσοστό εισφορών δημιουργήθηκε με επιτυχία!',
			'An error occurred!' : 'Προέκυψε ένα σφάλμα!',
			'Contribution Rate deleted successfully!' : 'Το ποσοστό εισφορών διαγράφηκε με επιτυχία!',
			'Salary Increase Rate Rate updated successfully!' : 'Το ποσοστό προσαύξησης μισθού ανανεώθηκε με επιτυχία!',
			'Salary Increase Rate Rate created successfully!' : 'Το ποσοστό προσαύξησης μισθού δημιουργήθηκε με επιτυχία!',
			'Salary Increase Rate Rate deleted successfully!' : 'Το ποσοστό προσαύξησης μισθού διαγράφηκε με επιτυχία!',
			'Extra Contribution Rate updated successfully!' : 'Το ποσοστό εισφορών υπερωριακών ωρών ανανεώθηκε με επιτυχία!',
			'Extra Contribution Rate created successfully!' : 'Το ποσοστό εισφορών υπερωριακών ωρών δημιουργήθηκε με επιτυχία!',
			'Extra Contribution Rate deleted successfully!' : 'Το ποσοστό εισφορών υπερωριακών ωρών διαγράφηκε με επιτυχία!',
			'Extra Contribution Rate':'Ποσοστό εισφορών υπερωριακών ωρών',
			'Required': 'Απαιτείται',
			'Insert a positive number': 'Εισάγετε έναν θετικό αριθμό',
			'Insert a valid date': 'Εισάγετε μία έγκυρη ημερομηνία'
		},
		en: {
		
		}
	},
}

export default locales